import { gql } from "@apollo/client";

const CHECK_REMITTANCE_FOR_APPROVAL = gql`
  query CheckRemittanceForApproval($params: SendRemittanceApprovalParams!) {
    checkRemittanceForApproval(params: $params) {
      hasApplicable
      message
      eligibleCount
    }
  }
`;

export default CHECK_REMITTANCE_FOR_APPROVAL;
